import { FunctionComponent } from "react";
import { IconProps } from "./constants";

const Money: FunctionComponent<IconProps> = ({ width = 16, height = 16, color = "#122A26", ...props }: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 16 16`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-name={props.name}
      data-testid={props.name}
      {...props}
    >
      <g id="Money">
        <g id="Ellipse 38">
          <circle cx="8" cy="8" r="7.25" stroke={color} strokeWidth="1.5" />
          <circle cx="8" cy="8" r="7.25" stroke="black" strokeOpacity="0.2" strokeWidth="1.5" />
        </g>
        <g id="Group 10292">
          <g id="Vector 21">
            <path
              d="M9.81667 6.02723V6.02723C9.81667 5.20749 9.15214 4.54297 8.33241 4.54297H7.59028C6.71199 4.54297 6 5.25496 6 6.13325V6.13325C6 7.01153 6.71199 7.72353 7.59028 7.72353H8.22639C9.10468 7.72353 9.81667 8.43552 9.81667 9.31381V9.31381C9.81667 10.1921 9.10468 10.9041 8.22639 10.9041H7.48426C6.66452 10.9041 6 10.2396 6 9.41982V9.41982"
              stroke={color}
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <path
              d="M9.81667 6.02723V6.02723C9.81667 5.20749 9.15214 4.54297 8.33241 4.54297H7.59028C6.71199 4.54297 6 5.25496 6 6.13325V6.13325C6 7.01153 6.71199 7.72353 7.59028 7.72353H8.22639C9.10468 7.72353 9.81667 8.43552 9.81667 9.31381V9.31381C9.81667 10.1921 9.10468 10.9041 8.22639 10.9041H7.48426C6.66452 10.9041 6 10.2396 6 9.41982V9.41982"
              stroke="black"
              strokeOpacity="0.2"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </g>
          <g id="Vector 22">
            <path d="M7.90845 4.5431V3.2002" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
            <path
              d="M7.90845 4.5431V3.2002"
              stroke="black"
              strokeOpacity="0.2"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </g>
          <g id="Vector 23">
            <path d="M7.90845 12.2472V10.9043" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
            <path
              d="M7.90845 12.2472V10.9043"
              stroke="black"
              strokeOpacity="0.2"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Money;
